import { globalGetService, globalExportService } from "../../utils/globalApiServices"
import { downloadFileType } from "../../utils";
import { trackActivity } from "../../utils/mixpanel";
import moment from "moment";
import { checkApiStatus } from "../../utils";


// export function getAircraftDetailApi(queryParams = {}, value) {
// 	const { asset, assetType } = queryParams.match.params
// 	return new Promise(function (resolve, reject) {
// 		this.setState({pageLoader:true})
// 		globalGetService(value ? `camo/asset/${value?.id}/${value?.asset_type}/view/?module=${queryParams?.module}`
// 				: queryParams?.module ?`camo/asset/${asset}/${assetType}/view/?module=${queryParams?.module}`: `camo/asset/${asset}/${assetType}/view/`
// 		).then((response) => {
// 				resolve(response)
// 				this.setState({pageLoader:true})
// 			}
// 		)
// 		this.setState({pageLoader:true})
// 	})
// }

export function getAircraftDetailApi(queryParams = {}, value, setPageLoaderFn) {
	const { asset, assetType } = queryParams.match.params;
	if (typeof setPageLoaderFn === 'function') {
		setPageLoaderFn(true);
	}
	return new Promise(function (resolve, reject) {
		globalGetService(value ? queryParams?.module ? `camo/asset/${value?.id}/${value?.asset_type}/view/?module=${queryParams?.module}` :
			`camo/asset/${value?.id}/${value?.asset_type}/view/`
			: queryParams?.module ? `camo/asset/${asset}/${assetType}/view/?module=${queryParams?.module}`
				: `camo/asset/${asset}/${assetType}/view/`
		).then((response) => {
			resolve(response);
			if (typeof setPageLoaderFn === 'function') {
				setPageLoaderFn(false);
			}
		}).catch((err) => {
			if (typeof setPageLoaderFn === 'function') {
				setPageLoaderFn(false);
			}
			reject(err);
		});
	});
}

export function getTechSpecDetailApi(props) {
	this.setState({ pageLoader: true })
	globalGetService(`camo/engine_tech_spec/${props?.slug}/details/`)
		.then(response => {
			if (checkApiStatus(response)) {
				this.setState({ pageLoader: false })
				this.setState({ basicDetailData: response?.data?.data })
			} else {
				this.setState({ pageLoader: false })
			}
		})
}

export function exportMasterReport(query = {}, match, enqueueSnackbar) {
	const date = new Date();
	const todayeDate = moment(String(date)).format("DD-MM-YYYY");
	globalExportService(`/camo/smbc_master_excel/${match?.params?.asset}/${match?.params?.assetType}/export/`)
		.then((response) => {
			if (checkApiStatus(response)) {
				downloadFileType(response.data, `Master_Export_${todayeDate}`, query);
				enqueueSnackbar("Master Export Download Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
				trackActivity("Master Export", { page_title: "Asset Listing", });
			} else {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
			}
		});
}
